<script>
import FormBlock from '@/components/FormBlock.vue';
import BaseButton from '@/components/BaseButton.vue';
import UserDetailTileField from '@/components/user/UserDetailTileField.vue';

export default {
  name: 'UserDetailContactsTile',
  components: { FormBlock, UserDetailTileField, BaseButton },
  props: {
    isEditMode: Boolean,
    value: Object,
  },
  computed: {
    contactsFields() {
      return [
        {   name: 'notificationsEmail',   title: 'E-mail',     value: this.value.email,      displayValue: this.value.notificationsEmail,   emptyValue: 'не указан',   displayView: 'vertical',     editView: 'vertical',     changeType: 'input',   borderBottom: true    }, // eslint-disable-line
        {   name: 'phone',                title: 'Телефон',    value: this.value.phone,      displayValue: this.value.phone,                emptyValue: 'не указан',   displayView: 'horizontal',   editView: 'horizontal',   changeType: 'input',                         }, // eslint-disable-line
        {   name: 'skype',                title: 'Skype',      value: this.value.skype,      displayValue: this.value.skype,                emptyValue: 'не указан',   displayView: 'horizontal',   editView: 'horizontal',   changeType: 'input',                         }, // eslint-disable-line
        {   name: 'telegram',             title: 'Telegram',   value: this.value.telegram,   displayValue: this.value.telegram,             emptyValue: 'не указан',   displayView: 'horizontal',   editView: 'horizontal',   changeType: 'input',                         }, // eslint-disable-line
        {   name: 'whatsapp',             title: 'Whatsapp',   value: this.value.whatsapp,   displayValue: this.value.whatsapp,             emptyValue: 'не указан',   displayView: 'horizontal',   editView: 'horizontal',   changeType: 'input',                         }, // eslint-disable-line
      ];
    },
  },
  methods: {
    onChange(name, value) {
      this.$emit('change', { [name]: value });
    },
  },
};
</script>

<template lang="pug">
FormBlock(mobile)
  .b-user-detail-contacts-tile(v-if="value")
    ._info
      ._header Контакты
      ._contacts-block
        UserDetailTileField(v-for="field in contactsFields" :key="field.name" :field="field" :isEditMode="isEditMode" @change="onChange(field.name, $event)")
    //._contacts-buttons
    //  BaseButton._contacts-button(blue round lg)
    //    ._contacts-button-text Добавить контакт
    //  BaseButton._contacts-button(grey round lg)
    //    ._contacts-button-text.-grey Больше контактов
</template>

<style scoped lang="scss">
.user-detail-contacts-tile {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  &__header {
    display: flex;
    padding-bottom: 15px;
    border-bottom: rgba(235, 239, 242, 1) 1px solid;
    font-family: Geometria, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(30, 49, 71, 1);
  }

  &__contacts-block {
    padding-bottom: 50px;
    padding-top: 25px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__contacts-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    bottom: 0;
  }

  &__contacts-button-text {
    font-size: 14px;
    font-family: Geometria, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    border-bottom: rgba(255, 255, 255, 1) 1px dashed;

    &--grey {
      border-bottom: rgba(120, 140, 161, 1) 1px dashed;
    }
  }
}
</style>
